import { render, staticRenderFns } from "./PlansTableLi.vue?vue&type=template&id=45281866&scoped=true&lang=pug"
import script from "./PlansTableLi.vue?vue&type=script&lang=js"
export * from "./PlansTableLi.vue?vue&type=script&lang=js"
import style0 from "./PlansTableLi.vue?vue&type=style&index=0&id=45281866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45281866",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
